
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-pastel-gradient dark:bg-[#121624]">
      <div className="text-center bg-white dark:bg-gray-800/60 p-10 rounded-xl border border-gray-200 dark:border-gray-700/50 shadow-card">
        <h1 className="text-5xl font-bold mb-4 text-custom-dark dark:text-custom-secondaryLight">404</h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-6">Oops! Page non trouvée</p>
        <a 
          href="/" 
          className="px-5 py-2.5 bg-custom-dark text-white rounded-md hover:bg-custom-dark/90 transition-all shadow-sm inline-block"
        >
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
};

export default NotFound;
